let config = {
  valve_C01_45: {
    // 实际值
    infactVal: 0,
    x: 400,
    y: 154,
    x2: 40,
    y2: 0,
    // 最大值
    max: 6,
    // 最小值
    min: 0,
    // 当前值
    val: 0.2,
    // 是否显示
    show: false,
    // 是否模拟
    isSimu: false,
    // 单位
    uni: 'bar',
    targetId: 'mainFrame',
    typeName: 'oilPressure'
  },
  valve_C01_37: {
    // 实际值
    infactVal: 0,
    x: 344,
    y: 940,
    x2: 40,
    y2: -90,
    max: 6,
    min: 0,
    val: 0.2,
    show: false,
    isSimu: false,
    uni: 'bar'
  },
  valve_C01_32: {
    // 实际值
    infactVal: 0,
    x: 773,
    y: 701,
    x2: 40,
    y2: -90,
    max: 6,
    min: 0,
    val: 0.2,
    show: false,
    isSimu: false,
    uni: 'bar'
  },
  valve_C01_25: {
    // 实际值
    infactVal: 0,
    x: 1355,
    y: 867,
    x2: 40,
    y2: -90,
    max: 6,
    min: 0,
    val: 0.2,
    show: false,
    isSimu: false,
    uni: 'bar'
  },
  valve_I01_15: {
    // 实际值
    infactVal: 0,
    x: 1468,
    y: 628,
    x2: 40,
    y2: 0,
    max: 6,
    min: 0,
    val: 0.2,
    show: false,
    isSimu: false,
    uni: 'bar',
    targetId: 'mainGenerator1',
    typeName: 'grease'
  },
  valve_I01_2: {
    // 实际值
    infactVal: 0,
    x: 1569,
    y: 260,
    x2: 40,
    y2: 0,
    max: 150,
    min: 0,
    val: 36,
    show: false,
    isSimu: false,
    uni: '℃',
    targetId: 'mainGenerator1',
    typeName: 'hyperthermiaWater'
  },
  // I01主机转速
  tab_I01_101: {
    // 实际值
    infactVal: 0,
    x: 214,
    y: 485,
    x2: 114,
    y2: 0,
    max: 1100,
    min: 0,
    val: 100,
    show: false,
    isSimu: false,
    uni: 'RPM',
    isRound: true,
    targetId: 'mainGenerator1',
    typeName: 'rpm'
  },
  valve_I02_15: {
    // 实际值
    infactVal: 0,
    x: 1468,
    y: 628,
    x2: 40,
    y2: 0,
    max: 6,
    min: 0,
    val: 0.2,
    show: false,
    isSimu: false,
    uni: 'bar',
    targetId: 'mainGenerator2',
    typeName: 'grease'
  },
  valve_I02_2: {
    // 实际值
    infactVal: 0,
    x: 1569,
    y: 260,
    x2: 40,
    y2: 0,
    max: 150,
    min: 0,
    val: 36,
    show: false,
    isSimu: false,
    uni: '℃',
    targetId: 'mainGenerator2',
    typeName: 'hyperthermiaWater'
  },
  // I02主机转速
  tab_I02_101: {
    // 实际值
    infactVal: 0,
    x: 214,
    y: 485,
    x2: 114,
    y2: 0,
    max: 1100,
    min: 0,
    val: 100,
    show: false,
    isSimu: false,
    uni: 'RPM',
    isRound: true,
    targetId: 'mainGenerator2',
    typeName: 'rpm'
  },
  valve_I03_15: {
    // 实际值
    infactVal: 0,
    x: 1468,
    y: 628,
    x2: 40,
    y2: 0,
    max: 6,
    min: 0,
    val: 0.2,
    show: false,
    isSimu: false,
    uni: 'bar',
    targetId: 'mainGenerator3',
    typeName: 'grease'
  },
  valve_I03_2: {
    // 实际值
    infactVal: 0,
    x: 1569,
    y: 260,
    x2: 40,
    y2: 0,
    max: 150,
    min: 0,
    val: 36,
    show: false,
    isSimu: false,
    uni: '℃',
    targetId: 'mainGenerator3',
    typeName: 'hyperthermiaWater'
  },
  // I03主机转速
  tab_I03_101: {
    // 实际值
    infactVal: 0,
    x: 214,
    y: 485,
    x2: 114,
    y2: 0,
    max: 1100,
    min: 0,
    val: 100,
    show: false,
    isSimu: false,
    uni: 'RPM',
    isRound: true,
    targetId: 'mainGenerator3',
    typeName: 'rpm'
  },
}

export default config